import React, { useMemo } from "react";
import Chart from "react-apexcharts";

const HACCPChart2 = ({ rekapHACCPGrade }) => {
  // Fungsi konversi data pivot (grade_a/b/c jadi grouped series)
  const convertToGroupedSeries = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return { categories: [], series: [] };
    }

    const categories = data.map((item) => item.nm_provinsi);

    const series = [
      {
        name: "Grade A",
        data: data.map((item) => item.grade_a || 0),
      },
      {
        name: "Grade B",
        data: data.map((item) => item.grade_b || 0),
      },
      {
        name: "Grade C",
        data: data.map((item) => item.grade_c || 0),
      },
    ];

    return { categories, series };
  };

  // Gunakan useMemo agar performa efisien
  const { categories, series } = useMemo(() => {
    const { categories, series } = convertToGroupedSeries(rekapHACCPGrade);

    return {
      categories: categories.map(cat => cat.toUpperCase()),
      series
    };
  }, [rekapHACCPGrade]);

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      fontFamily: '"Inter", sans-serif',
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: "55%",
        barHeight: "65%",
        borderRadius: 3,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
      labels: {
        style: {
          colors: "#004D40", 
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: categories.map(() => "#004D40"), 
          fontSize: "12px",
        }
      }
    },
    tooltip: {
      enabled: true,
    },
    legend: {
      position: "bottom",
    },
    colors: ["#0071CE", "#F7941E", "#4BA38A"],
  };


  return (
    <div>
      <Chart
        options={chartOptions}
        series={series}
        type="bar"
        height={categories.length * 50} // Dinamis berdasarkan jumlah provinsi
      />
    </div>
  );
};

export default HACCPChart2;
